import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Filter, Search, Brain, Terminal, Database, Lock } from 'lucide-react';
const products = [{
  id: 1,
  title: 'Neural OS: Sistema de Segundo Cerebro',
  category: 'Sistemas',
  price: 149,
  badge: 'Bestseller',
  icon: Brain,
  color: 'from-lab-violet to-lab-blue'
}, {
  id: 2,
  title: 'Prompt Engineering Masterclass',
  category: 'Educación',
  price: 299,
  badge: 'Nuevo',
  icon: Terminal,
  color: 'from-lab-blue to-lab-neon'
}, {
  id: 3,
  title: 'Arquitectura de Datos Personales',
  category: 'Sistemas',
  price: 89,
  badge: null,
  icon: Database,
  color: 'from-gray-600 to-gray-400'
}, {
  id: 4,
  title: 'Protocolo de Enfoque Profundo',
  category: 'Neuro-Optimización',
  price: 49,
  badge: 'Esencial',
  icon: Lock,
  color: 'from-lab-violetLight to-pink-500'
}];
export const Catalog = () => {
  return <div className="min-h-screen pt-32 pb-24" data-id="element-139">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-140">
        {/* Header */}
        <div className="mb-16" data-id="element-141">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-6xl font-display font-bold mb-6" data-id="element-142">
            Laboratorio de <span className="text-gradient" data-id="element-143">Sistemas</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lab-muted text-lg max-w-2xl" data-id="element-144">
            Catálogo completo de herramientas, frameworks y arquitecturas
            diseñadas para expandir tu capacidad cognitiva y operativa.
          </motion.p>
        </div>

        {/* Filters & Search */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-12" data-id="element-145">
          <div className="flex items-center gap-2 w-full md:w-auto overflow-x-auto pb-2 md:pb-0 hide-scrollbar" data-id="element-146">
            {['Todos', 'Sistemas', 'Educación', 'Neuro-Optimización'].map((filter, idx) => <button key={filter} className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-colors ${idx === 0 ? 'bg-white text-black' : 'glass-panel text-lab-muted hover:text-white'}`} data-id="element-147">
                  {filter}
                </button>)}
          </div>

          <div className="w-full md:w-64 relative" data-id="element-148">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-lab-muted" size={18} data-id="element-149" />
            <input type="text" placeholder="Buscar sistemas..." className="w-full bg-white/5 border border-white/10 rounded-full py-2 pl-10 pr-4 text-sm text-white focus:outline-none focus:border-lab-violetLight/50 transition-colors" data-id="element-150" />
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-151">
          {products.map((product, idx) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} data-id="element-152">
              <Link to={`/product/${product.id}`} className="group block h-full" data-id="element-153">
                <div className="glass-card rounded-2xl overflow-hidden h-full flex flex-col" data-id="element-154">
                  {/* Visual Area */}
                  <div className="aspect-video relative bg-[#0a0a0f] flex items-center justify-center overflow-hidden border-b border-white/5" data-id="element-155">
                    <div className="absolute inset-0 bg-gradient-to-br opacity-0 group-hover:opacity-20 transition-opacity duration-500 z-10" data-id="element-156" />
                    {product.badge && <div className="absolute top-4 left-4 z-20" data-id="element-157">
                        <span className={`px-3 py-1 text-xs font-mono rounded-full font-medium ${product.badge === 'Bestseller' ? 'bg-white text-black' : 'glass-panel text-white'}`} data-id="element-158">
                          {product.badge}
                        </span>
                      </div>}

                    {/* Abstract Icon */}
                    <div className="relative z-10 w-20 h-20 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-500" data-id="element-159">
                      <div className={`absolute inset-0 bg-gradient-to-br ${product.color} opacity-20 blur-xl rounded-full`} data-id="element-160" />
                      <product.icon className="text-white/80 relative z-10" size={32} data-id="element-161" />
                    </div>
                  </div>

                  {/* Content Area */}
                  <div className="p-6 flex flex-col flex-grow" data-id="element-162">
                    <div className="text-xs font-mono text-lab-violetLight mb-2 uppercase tracking-wider" data-id="element-163">
                      {product.category}
                    </div>
                    <h3 className="text-xl font-display font-bold text-white mb-4 group-hover:text-lab-neon transition-colors line-clamp-2" data-id="element-164">
                      {product.title}
                    </h3>
                    <div className="mt-auto flex items-center justify-between pt-4 border-t border-white/5" data-id="element-165">
                      <span className="font-mono text-white font-medium" data-id="element-166">
                        ${product.price} USD
                      </span>
                      <span className="text-sm text-lab-muted group-hover:text-white transition-colors flex items-center gap-1" data-id="element-167">
                        Explorar{' '}
                        <Filter size={14} className="rotate-[-90deg]" data-id="element-168" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </div>;
};